import React, { useEffect, useState } from "react";
import { Rate } from "antd";
import FeedbackSection from "../FeedbackSection/FeedbackSection";
import "./DetailsModal.css";

const DetailsModal = ({ isOpen, onClose, service }) => {
    const [show, setShow] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setShow(true);
            setTimeout(() => setVisible(true), 10);
        } else {
            setVisible(false);
            setTimeout(() => setShow(false), 300);
        }
    }, [isOpen]);

    if (!show || !service) return null;

    return (
        <div className={`modal-overlay ${visible ? "show" : "hide"}`}>
            <div className={`modal-content ${visible ? "slide-up" : "slide-down"}`}>
                <div className="modal-header">
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body">
                    <h2>{service.name}</h2>
                    <img src={service.img} alt={service.name} className="service-image" />
                    <div className="price-section">
                        <span className="discounted">Rs.{service.discountedPrice}</span>
                        <span className="original">Rs.{service.originalPrice}</span>
                    </div>
                    <div className="rating-section">
                        <Rate defaultValue={service.rating} disabled allowHalf />
                    </div>
                    <div className="description">
                        <h3>Service Includes:</h3>
                        <ul>
                            {(Array.isArray(service.description) ? service.description : [service.description]).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                    <FeedbackSection />
                </div>
            </div>
        </div>
    );
};

export default DetailsModal;
